import qs from 'qs'
import { AxiosRequestConfig } from 'axios'
import { createAxios } from 'nextjs-tools/axiosInstance'
import { createContext } from 'react'

const options: AxiosRequestConfig = {
  withCredentials: true,
  baseURL: typeof window !== 'undefined' ? `${window?.location.origin}/api/v2` : '',
  responseType: 'json',
  paramsSerializer: (params) => qs.stringify(params, { indices: false }),
}

export const createMainAxiosInstance = () => createAxios(options)

export const AxiosContext = createContext(createMainAxiosInstance())
